export default {
  "三": `
    [12,12]

       +++++++



        +++++



      +++++++++


  `,
  "原": `
    [12,12]
      ++++++++
      +   +
      + +++++
      + +   +
      + +++++
      + +   +
      + +++++
      +   +
     +  + + +
     + +  +  +
    +    ++

  `,
  "色": `
    [12,12]
       +
      +++++
     +   +
    +   +
     +++++++
     +  +  +
     +  +  +
     +++++++
     +
     +     +
      ++++++

  `,
}



// WEBPACK FOOTER //
// ./src/dot-fonts/chinese.js